import { FC } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { IconX } from '@tabler/icons';
import { ActionIcon, Center } from '@mantine/core';
import { UseListStateHandlers } from '@mantine/hooks';
import DocumentEventStatus from '../../../Molecules/Event/Documents/DocumentEventStatus';
import { WorkflowDTO } from '../../../Types/LogT';
import { WorkflowS } from '../../../Service/WorkflowS';
import { openDeleteConfirmModal } from '../../../Atoms/DeleteConfirmModal';

interface Props {
  idx: number;
  workflow: WorkflowDTO;
  handlers: UseListStateHandlers<WorkflowDTO>;
}

const EventWorkflowListItem: FC<Props> = ({ idx, workflow, handlers }) => {
  const navigate: NavigateFunction = useNavigate();
  const { remove } = handlers;

  // eslint-disable-next-line no-underscore-dangle
  const _onClick = () => {
    navigate(`/events/${workflow.eventId}/details`);
  };

  const removeHandler = () => {
    const onConfirm = async () => {
      const deleted = await WorkflowS.deleteWorkflow(workflow);
      if (deleted) {
        remove(idx);
      }
      return deleted;
    };
    openDeleteConfirmModal({
      title: 'Wirklich löschen?',
      description: 'Wollen Sie den Workflow wirklich entfernen?',
      onConfirm,
    });
  };

  return (
    <tr>
      <td onClick={_onClick} style={{ cursor: 'pointer' }}>
        {workflow.name}
      </td>

      <td onClick={_onClick}>
        {workflow.eventId && <DocumentEventStatus shortVersion={false} eventId={workflow.eventId} hideDate={false} />}
      </td>
      <td style={{ position: 'relative' }}>
        <Center>
          <div style={{ position: 'absolute', right: 5 }}>
            <ActionIcon size="xs" onClick={removeHandler}>
              <IconX />
            </ActionIcon>
          </div>
        </Center>
      </td>
    </tr>
  );
};

export default EventWorkflowListItem;
